// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SessionsPopup__wrapper-e8661b {
  overflow-y: auto;
  margin-bottom: 16px;
}

.SessionsPopup__title-e0554d {
  font: var(--font-subtitle-1);
  color: var(--base-80);
  margin: 16px 24px 0px 24px;
  letter-spacing: var(--font-spacing-subtitle-1);
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/Sessions/SessionsPopup/SessionsPopup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,4BAAA;EACA,qBAAA;EACA,0BAAA;EACA,8CAAA;AACF","sourcesContent":[".wrapper {\n  overflow-y: auto;\n  margin-bottom: 16px;\n}\n\n.title {\n  font: var(--font-subtitle-1);\n  color: var(--base-80);\n  margin: 16px 24px 0px 24px;\n  letter-spacing: var(--font-spacing-subtitle-1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `SessionsPopup__wrapper-e8661b`,
	"title": `SessionsPopup__title-e0554d`
};
module.exports = ___CSS_LOADER_EXPORT___;
